var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 18.403,
    viewBox: "0 0 30 18.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(-602 -91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    transform: "translate(602 91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M-297.875-19.167q-6.875,0-13.751,0c-.221,0-.3.046-.3.287q.01,7.953,0,15.907c0,.239.077.288.3.288q13.751-.008,27.5,0c.308,0,.309,0,.309-.318q0-7.918,0-15.835c0-.319,0-.319-.331-.319h-13.727m15.006,17.438c-.1,0-.191-.013-.286-.013h-29.428c-.1,0-.191.008-.286.013v-18.4c.1,0,.191.013.286.013h29.428c.1,0,.191-.008.286-.013Z",
    transform: "translate(312.869 20.132)",
    fill: "#ec812d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(609 95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M-101.333-50.667a5.334,5.334,0,0,1-5.334,5.334A5.334,5.334,0,0,1-112-50.666,5.334,5.334,0,0,1-106.667-56a5.334,5.334,0,0,1,5.334,5.334",
    transform: "translate(112.001 56.001)",
    fill: "#ec812d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(615.334 95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M-101.333-50.667a5.334,5.334,0,0,1-5.334,5.334A5.334,5.334,0,0,1-112-50.666,5.334,5.334,0,0,1-106.667-56a5.334,5.334,0,0,1,5.334,5.334",
    transform: "translate(112.001 56.001)",
    fill: "#fee5d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(615.334 96.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M0-40.766a5.326,5.326,0,0,0,2.167,4.292,5.326,5.326,0,0,0,2.167-4.292,5.326,5.326,0,0,0-2.167-4.292A5.326,5.326,0,0,0,0-40.766",
    transform: "translate(0 45.058)",
    fill: "#ffa584"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M0-112H17v10.668H0Z",
    transform: "translate(609 207.001)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaster);
export default __webpack_public_path__ + "static/media/icon-master.950a48154bf9487e58ddde183f1af490.svg";
export { ForwardRef as ReactComponent };